import templateUrl from './radio-buttons.html';

export const radioButtonsComponent = {
    bindings: {
        title: '@',
		options: '<',
		defaultSelectedOptionId: '@',
		onChange: '&',
		isRequired : '<'
    },

    templateUrl,

    controller: class RadioButtonsComponent {
        constructor($parse) {
            'ngInject';

            this.$parse = $parse;
        }

        $onInit() {
			this.name = new Date().getTime()+Math.random();
			this._isRequired = this.$parse(this.isRequired || 'true')(true);
		}
		
		_onChange($event) {
			this.onChange({
				$event: {
					id: this.defaultSelectedOptionId
				}
			});
		}
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/radio-buttons/radio-buttons.component.js